export const normalizeUsername = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^[._-]+|[._-]+$/g, "")
    .slice(0, 64);

export const isValidUsername = (value: string): boolean =>
  /^[a-z0-9][a-z0-9._-]*[a-z0-9]$/.test(value) &&
  value.length >= 3 &&
  value.length <= 64;
